export const externalLinkLabels = {
    title: "Intersite Interstitial Component",
    header: "Leaving Moderna Direct",
    subHeader: "You are now leaving Moderna Direct. The intended use and audience for the linked website may differ.",
    remindMeText: "Don't remind me again",
    buttonLabel: "Continue"
}

export const socialLink = {
    title: 'External Interstitial Modal',
    header: 'You are about to leave',
    subHeader: 'Moderna\'s Website',
    message: `You are being redirected to an external website not controlled by Moderna. We cannot assume responsibility for the information or statements made from these sources. Our [PRIVACY_POLICY] will not apply.`,
    remindMeText: 'Don\'t remind me again',
    buttonLabel: 'Open Link'
}